import { smoothScrollTo } from './_scrolling.js';

class AccordionsModule {
  constructor(container) {
    this.container = container;
    this.baseClass = container.classList[0]; // <-- FIRST class becomes the baseClass
    this.accordionPanels = container.querySelectorAll(`.${this.baseClass}__panel`);
    this.accordionQuestions = container.querySelectorAll(`.${this.baseClass}__question`);
    this.accordionImages = container.querySelectorAll(`.${this.baseClass}__image`);
    this.init();
  }

  init() {
    this.accordionQuestions.forEach(question => {
      question.addEventListener('click', (e) => this.togglePanel(e, question));
      question.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          question.click();
        }
      });
    });
  }

  togglePanel(event, question) {
    const expanded = question.getAttribute('aria-expanded') === 'true';
    const answerId = question.getAttribute('aria-controls');
    const answer = this.container.querySelector(`#${answerId}`);
    const panel = question.closest(`.${this.baseClass}__panel`);
    const panelIndex = Array.from(this.accordionPanels).indexOf(panel);

    this.accordionPanels.forEach((panel, index) => {
      const panelQuestion = panel.querySelector(`.${this.baseClass}__question`);
      const panelAnswer = panel.querySelector(`.${this.baseClass}__answer`);
      const icon = panelQuestion.querySelector(`.${this.baseClass}__toggle i`);

      panelAnswer.style.height = panelAnswer.scrollHeight + 'px';
      panelAnswer.offsetHeight;
      panelAnswer.style.height = '0';

      panel.classList.remove('active');
      panelQuestion.setAttribute('aria-expanded', 'false');
      panelAnswer.setAttribute('aria-hidden', 'true');

      if (icon) {
        icon.classList.remove('icon--minus');
        icon.classList.add('icon--plus');
      }

      if (this.accordionImages[index]) {
        this.accordionImages[index].classList.remove('active');
      }
    });

    if (!expanded) {
      question.setAttribute('aria-expanded', 'true');
      panel.classList.add('active');
      answer.style.height = answer.scrollHeight + 'px';
      answer.setAttribute('aria-hidden', 'false');

      const activeIcon = question.querySelector(`.${this.baseClass}__toggle i`);
      if (activeIcon) {
        activeIcon.classList.remove('icon--plus');
        activeIcon.classList.add('icon--minus');
      }

      if (this.accordionImages[panelIndex]) {
        this.accordionImages[panelIndex].classList.add('active');
      }
    }

    if (!this.container.querySelector(`.${this.baseClass}__panel.active`) && this.accordionImages.length > 0) {
      this.accordionImages[0].classList.add('active');
    }

    if (!expanded) {
      setTimeout(() => {
        const panelRect = panel.getBoundingClientRect();
        const panelTop = panelRect.top + window.scrollY;
        const panelHeight = panelRect.height;
        const viewportHeight = window.innerHeight;

        const nav = document.querySelector('.navigation');
        const navHeight = nav ? nav.offsetHeight : 0;

        const isNearTop = panelRect.top < navHeight;

        const scrollTo = isNearTop
          ? panelTop - navHeight
          : panelTop - (viewportHeight / 2 - panelHeight / 2);

        if ('scrollBehavior' in document.documentElement.style && !/Safari/.test(navigator.userAgent)) {
          window.scrollTo({ top: scrollTo, behavior: 'smooth' });
        } else {
          // Use custom smooth scroll for Safari
          smoothScrollTo(scrollTo, 500);
        }
      }, 500);
    }
  }
}

// Initialize each module
document.querySelectorAll('.accordions, .outcomes').forEach(moduleContainer => {
  new AccordionsModule(moduleContainer);
});
